<script>
import request from '@/services/request';
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';

export default {

    name: 'ModarServicesExtrasComponentAll',

    props: {

        prop_edit: {
            default: true,
        },

    },


    data() {

        return {

            catalogue:
                new Catalogue(),

            search: {

                user_id:
                    '',

                department_id:
                    '',

                tenant_id:
                    '',

            },

            tenants:
                [],

            errors:
                {},

            tenant: {

                id:
                    '',

            },

            pays:
                [],

            loadingTenants:
                false,

            loadingPays:
                false,

            saving:
                false,

        };

    },


    computed: {

        totalAmount() {

            return this.pays.reduce(
                (
                    sum,
                    pay
                ) => {

                    const amount =
                        parseFloat(
                            pay.amount || 0
                        );

                    return pay.negative == 1
                        ? sum - amount
                        : sum + amount;

                },
                0
            );

        },


        canAddConcept() {

            return Boolean(
                this.prop_edit &&
                this.tenant &&
                this.tenant.id
            );

        },


        canSave() {

            return Boolean(
                this.prop_edit &&
                this.tenant &&
                this.tenant.id &&
                this.pays.length &&
                !this.saving
            );

        },


        selectedUserName() {

            if (
                !this.search.user_id ||
                !Array.isArray(
                    this.catalogue.users_profile
                )
            ) {

                return '';

            }

            const user =
                this.catalogue.users_profile
                    .find(
                        item =>
                            String(item.id) ===
                            String(
                                this.search.user_id
                            )
                    );

            if (!user) {

                return '';

            }

            return [
                user.name,
                user.last_name,
            ]
                .filter(Boolean)
                .join(' ')
                .trim();

        },

    },


    methods: {

        getDepartment() {

            this.search.department_id =
                '';

            this.search.tenant_id =
                '';

            this.tenant = {
                id: '',
            };

            this.tenants = [];

            this.pays = [];

            if (
                this.search.user_id
            ) {

                this.catalogue
                    .get_departamens_user(
                        this.search.user_id
                    );

            }

        },


        async getTenants() {

            this.search.tenant_id =
                '';

            this.tenant = {
                id: '',
            };

            this.tenants = [];

            this.pays = [];

            if (
                !this.search.department_id ||
                !this.search.user_id
            ) {

                return;

            }

            const search = {

                user_id:
                    this.search.user_id,

                department_id:
                    this.search.department_id,

            };

            const endpoint =
                '/contracts_user';

            this.loadingTenants =
                true;

            try {

                let { data } =
                    await request.get(
                        endpoint,
                        search
                    );

                this.tenants =
                    Array.isArray(data)
                        ? data
                        : [];

            } catch (error) {

                this.tenants = [];

                await this.errorNotification(
                    error
                );

            } finally {

                this.loadingTenants =
                    false;

            }

        },


        getTenant() {

            this.tenant = {
                id:
                    this.search.tenant_id || '',
            };

            this.pays = [];

            if (
                this.tenant.id
            ) {

                this.list();

            }

        },


        closedModal() {

            this.pays = [];

            this.tenant = {
                id: '',
            };

            this.search = {

                user_id:
                    '',

                department_id:
                    '',

                tenant_id:
                    '',

            };

            this.tenants = [];

            this.errors = {};

            this.loadingTenants =
                false;

            this.loadingPays =
                false;

            this.saving =
                false;

            Event.$emit(
                'event-load-tenants'
            );

            this.$modal.hide(
                'ListServicesExtrasAll'
            );

        },


        async list() {

            if (
                !this.tenant.id
            ) {

                this.pays = [];

                return;

            }

            this.pays = [];

            this.loadingPays =
                true;

            const endpoint =
                '/contract_dues_extras?id=' +
                this.tenant.id;

            try {

                let { data } =
                    await request.get(
                        endpoint
                    );

                this.pays =
                    Array.isArray(data)
                        ? data
                        : [];

            } catch (error) {

                this.pays = [];

                await this.errorNotification(
                    error
                );

            } finally {

                this.loadingPays =
                    false;

            }

        },


        async saveAll() {

            if (
                !this.canSave
            ) {

                return;

            }

            const endpoint =
                '/contract_dues_extras?id=' +
                this.tenant.id;

            const data_form = {

                services:
                    this.pays,

            };

            this.saving =
                true;

            try {

                let { data } =
                    await request.postMedia(
                        endpoint,
                        data_form
                    );

                if (data) {

                    Event.$emit(
                        'event-load-contract_dues'
                    );

                    this.successNotification(
                        data
                    );

                    this.closedModal();

                }

            } catch (error) {

                this.errors =
                    await this.errorNotification(
                        error
                    );

            } finally {

                this.saving =
                    false;

            }

        },


        addServices() {

            if (
                !this.canAddConcept
            ) {

                return;

            }

            const service = {

                id:
                    '',

                service_id:
                    null,

                contract_due_id:
                    this.tenant.id,

                base_amount:
                    0,

                description:
                    '',

            };

            this.pays.push(
                service
            );

        },


        deleteServices(index) {

            this.$swal({

                title:
                    'Eliminar concepto',

                text:
                    '¿Deseas quitar este concepto del cargo extra?',

                icon:
                    'warning',

                showCancelButton:
                    true,

                confirmButtonColor:
                    '#d84d5d',

                cancelButtonColor:
                    '#6b7280',

                confirmButtonText:
                    'Sí, eliminar',

                cancelButtonText:
                    'Cancelar',

                reverseButtons:
                    true,

            }).then(
                async result => {

                    if (
                        !result.isConfirmed
                    ) {

                        return;

                    }

                    this.pays.splice(
                        index,
                        1
                    );

                    this.successNotification(
                        'Concepto eliminado. Recuerda guardar los cambios.'
                    );

                }
            );

        },


        ...mapActions({

            errorNotification:
                'alert/error',

            successNotification:
                'alert/success',

        }),

    },


    mounted() {

        this.catalogue
            .get_users_profile(7);

    },


    created() {

        Event.$on(
            'event-list-extra-services-all',
            () => {

                this.$modal.show(
                    'ListServicesExtrasAll'
                );

            }
        );

    },


    beforeDestroy() {

        Event.$off(
            'event-list-extra-services-all'
        );

    },


    watch: {

        pays: {

            handler(newPays) {

                newPays.forEach(
                    pay => {

                        pay.amount =
                            parseFloat(
                                pay.base_amount || 0
                            );

                    }
                );

            },

            deep:
                true,

        },

    },

};
</script>


<template>

    <modal
        name="ListServicesExtrasAll"
        :width="'920px'"
        :height="'auto'"
        :adaptive="true"
        :scrollable="true"
        :click-to-close="false"
    >

        <div class="extra-contract-form">

            <!-- ==========================================
                 ENCABEZADO
            =========================================== -->

            <div class="form-header">

                <div class="form-header__content">

                    <div class="form-header__icon">

                        <i
                            class="
                                fa-solid
                                fa-file-invoice-dollar
                            "
                        ></i>

                    </div>


                    <div>

                        <h5 class="form-header__title">
                            Cargo extra con contrato
                        </h5>

                        <p class="form-header__subtitle">
                            Selecciona el contrato y captura los conceptos que
                            formarán el adeudo extraordinario.
                        </p>

                    </div>

                </div>


                <button
                    type="button"
                    class="form-close"
                    title="Cerrar"
                    aria-label="Cerrar formulario"
                    @click="closedModal"
                >

                    <i
                        class="
                            fa-solid
                            fa-xmark
                        "
                    ></i>

                </button>

            </div>


            <!-- ==========================================
                 CONTENIDO
            =========================================== -->

            <div class="form-body">

                <!-- ======================================
                     PASO 1 - CONTRATO
                ======================================= -->

                <section class="form-section">

                    <div class="section-header">

                        <div class="section-number">
                            1
                        </div>


                        <div>

                            <h6 class="section-title">
                                Selecciona el contrato
                            </h6>

                            <p class="section-description">
                                Primero selecciona el cliente, después el indiviso
                                y finalmente el periodo donde se agregará el cargo.
                            </p>

                        </div>

                    </div>


                    <div class="contract-selector-grid">

                        <!-- CLIENTE -->

                        <div class="form-group">

                            <label class="field-label">

                                Cliente

                                <span class="required-mark">
                                    *
                                </span>

                            </label>


                            <select
                                class="form-control"
                                v-model="search.user_id"
                                :disabled="loadingPays || saving"
                                @change="getDepartment"
                            >

                                <option value="">
                                    Selecciona un cliente
                                </option>


                                <option
                                    v-for="
                                        user
                                        in catalogue.users_profile
                                    "
                                    :key="user.id"
                                    :value="user.id"
                                >

                                    {{ user.name }}
                                    {{ user.last_name }}

                                </option>

                            </select>


                            <small class="field-help">
                                Cliente al que pertenece el contrato.
                            </small>

                        </div>


                        <!-- INDIVISO -->

                        <div class="form-group">

                            <label class="field-label">

                                Indiviso

                                <span class="required-mark">
                                    *
                                </span>

                            </label>


                            <select
                                class="form-control"
                                v-model="search.department_id"
                                :disabled="
                                    !search.user_id ||
                                    loadingPays ||
                                    saving
                                "
                                @change="getTenants"
                            >

                                <option value="">
                                    Selecciona un indiviso
                                </option>


                                <option
                                    v-for="
                                        company
                                        in catalogue.departamens_user
                                    "
                                    :key="company.id"
                                    :value="company.id"
                                >

                                    {{ company.name }}

                                </option>

                            </select>


                            <small class="field-help">

                                <span
                                    v-if="
                                        !search.user_id
                                    "
                                >
                                    Primero selecciona un cliente.
                                </span>

                                <span v-else>
                                    Indiviso relacionado al contrato.
                                </span>

                            </small>

                        </div>


                        <!-- PERIODO -->

                        <div class="form-group">

                            <label class="field-label">

                                Periodo

                                <span class="required-mark">
                                    *
                                </span>

                            </label>


                            <div class="select-loading-wrapper">

                                <select
                                    class="form-control"
                                    v-model="search.tenant_id"
                                    :disabled="
                                        !search.department_id ||
                                        loadingTenants ||
                                        loadingPays ||
                                        saving
                                    "
                                    @change="getTenant"
                                >

                                    <option value="">
                                        Selecciona un periodo
                                    </option>


                                    <option
                                        v-for="
                                            tenant
                                            in tenants
                                        "
                                        :key="tenant.id"
                                        :value="tenant.id"
                                    >

                                        {{
                                            tenant.due_date
                                            | toDateTime
                                        }}

                                    </option>

                                </select>


                                <i
                                    v-if="loadingTenants"
                                    class="
                                        fa-solid
                                        fa-circle-notch
                                        fa-spin
                                        select-loading-icon
                                    "
                                ></i>

                            </div>


                            <small class="field-help">

                                <span
                                    v-if="
                                        loadingTenants
                                    "
                                >
                                    Consultando periodos...
                                </span>

                                <span
                                    v-else-if="
                                        !search.department_id
                                    "
                                >
                                    Selecciona primero un indiviso.
                                </span>

                                <span v-else>
                                    Adeudo donde se registrará el cargo.
                                </span>

                            </small>

                        </div>

                    </div>


                    <!-- CONTEXTO SELECCIONADO -->

                    <div
                        v-if="
                            search.user_id ||
                            search.department_id ||
                            search.tenant_id
                        "
                        class="selection-context"
                    >

                        <div class="selection-context__icon">

                            <i
                                class="
                                    fa-solid
                                    fa-link
                                "
                            ></i>

                        </div>


                        <div>

                            <small>
                                Contexto seleccionado
                            </small>

                            <strong>

                                <span
                                    v-if="selectedUserName"
                                >
                                    {{ selectedUserName }}
                                </span>

                                <span
                                    v-if="
                                        search.department_id
                                    "
                                >
                                    · Indiviso seleccionado
                                </span>

                                <span
                                    v-if="
                                        search.tenant_id
                                    "
                                >
                                    · Periodo seleccionado
                                </span>

                            </strong>

                        </div>

                    </div>

                </section>


                <!-- ======================================
                     PASO 2 - CONCEPTOS
                ======================================= -->

                <section class="form-section form-section--concepts">

                    <div class="section-header section-header--actions">

                        <div class="section-header__left">

                            <div class="section-number">
                                2
                            </div>


                            <div>

                                <h6 class="section-title">
                                    Conceptos del cargo extra
                                </h6>

                                <p class="section-description">
                                    Agrega uno o varios conceptos con su importe.
                                </p>

                            </div>

                        </div>


                        <button
                            v-if="prop_edit"
                            type="button"
                            class="
                                btn
                                btn-sm
                                btn-outline-primary
                                add-concept-button
                            "
                            :disabled="
                                !canAddConcept ||
                                loadingPays ||
                                saving
                            "
                            @click="addServices"
                        >

                            <i
                                class="
                                    fa-solid
                                    fa-plus
                                    mr-1
                                "
                            ></i>

                            Agregar concepto

                        </button>

                    </div>


                    <!-- ESTADO: SIN PERIODO -->

                    <div
                        v-if="
                            !tenant.id &&
                            !loadingPays
                        "
                        class="empty-state"
                    >

                        <div class="empty-state__icon">

                            <i
                                class="
                                    fa-solid
                                    fa-file-circle-plus
                                "
                            ></i>

                        </div>


                        <div>

                            <strong>
                                Selecciona un periodo para continuar
                            </strong>

                            <p>
                                Los conceptos del cargo extra se mostrarán
                                después de seleccionar cliente, indiviso y periodo.
                            </p>

                        </div>

                    </div>


                    <!-- ESTADO: CARGANDO -->

                    <div
                        v-else-if="loadingPays"
                        class="loading-state"
                    >

                        <i
                            class="
                                fa-solid
                                fa-circle-notch
                                fa-spin
                            "
                        ></i>

                        <span>
                            Consultando conceptos del periodo...
                        </span>

                    </div>


                    <!-- TABLA -->

                    <div
                        v-else-if="pays.length"
                        class="concept-table-wrapper"
                    >

                        <table class="concept-table">

                            <thead>

                                <tr>

                                    <th>
                                        Concepto
                                    </th>

                                    <th class="amount-column">
                                        Importe
                                    </th>

                                    <th
                                        v-if="prop_edit"
                                        class="actions-column"
                                    >
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                <tr
                                    v-for="
                                        (
                                            pay,
                                            index
                                        )
                                        in pays
                                    "
                                    :key="
                                        pay.id ||
                                        index
                                    "
                                >

                                    <!-- DESCRIPCIÓN -->

                                    <td>

                                        <div class="concept-input">

                                            <div class="concept-index">
                                                {{ index + 1 }}
                                            </div>


                                            <input
                                                v-model="
                                                    pay.description
                                                "
                                                :disabled="
                                                    !prop_edit ||
                                                    saving
                                                "
                                                type="text"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                "
                                                placeholder="
                                                    Ej. Reparación,
                                                    penalización,
                                                    servicio adicional...
                                                "
                                            >

                                        </div>

                                    </td>


                                    <!-- IMPORTE -->

                                    <td class="amount-column">

                                        <div class="amount-field">

                                            <span
                                                class="
                                                    amount-field__symbol
                                                "
                                            >
                                                $
                                            </span>


                                            <money
                                                v-model="
                                                    pay.base_amount
                                                "
                                                :disabled="
                                                    !prop_edit ||
                                                    saving
                                                "
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    amount-field__input
                                                "
                                            />

                                        </div>

                                    </td>


                                    <!-- ELIMINAR -->

                                    <td
                                        v-if="prop_edit"
                                        class="
                                            actions-column
                                            text-center
                                        "
                                    >

                                        <button
                                            type="button"
                                            class="
                                                btn
                                                btn-sm
                                                btn-outline-danger
                                                remove-concept-button
                                            "
                                            :disabled="saving"
                                            title="Eliminar concepto"
                                            @click="
                                                deleteServices(
                                                    index
                                                )
                                            "
                                        >

                                            <i
                                                class="
                                                    fa-solid
                                                    fa-trash
                                                "
                                            ></i>

                                        </button>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>


                    <!-- ESTADO: SIN CONCEPTOS -->

                    <div
                        v-else
                        class="empty-state"
                    >

                        <div class="empty-state__icon">

                            <i
                                class="
                                    fa-solid
                                    fa-receipt
                                "
                            ></i>

                        </div>


                        <div>

                            <strong>
                                Sin conceptos registrados
                            </strong>

                            <p>
                                Agrega el primer concepto para formar
                                el cargo extra de este periodo.
                            </p>


                            <button
                                v-if="prop_edit"
                                type="button"
                                class="
                                    btn
                                    btn-sm
                                    btn-outline-primary
                                    mt-2
                                "
                                @click="addServices"
                            >

                                <i
                                    class="
                                        fa-solid
                                        fa-plus
                                        mr-1
                                    "
                                ></i>

                                Agregar primer concepto

                            </button>

                        </div>

                    </div>


                    <!-- RESUMEN TOTAL -->

                    <div
                        v-if="
                            tenant.id &&
                            pays.length
                        "
                        class="concept-total"
                    >

                        <div>

                            <small>
                                {{ pays.length }}
                                {{
                                    pays.length === 1
                                        ? 'concepto'
                                        : 'conceptos'
                                }}
                            </small>

                            <span>
                                Total del cargo extra
                            </span>

                        </div>


                        <strong>
                            {{
                                totalAmount
                                | toCurrency
                            }}
                        </strong>

                    </div>

                </section>

            </div>


            <!-- ==========================================
                 FOOTER
            =========================================== -->

            <div class="form-footer">

                <button
                    type="button"
                    class="
                        btn
                        btn-light
                        footer-button
                    "
                    :disabled="saving"
                    @click="closedModal"
                >
                    Cancelar
                </button>


                <button
                    v-if="prop_edit"
                    type="button"
                    class="
                        btn
                        btn-success
                        footer-button
                        footer-button--save
                    "
                    :disabled="
                        !canSave
                    "
                    @click="saveAll"
                >

                    <i
                        v-if="saving"
                        class="
                            fa-solid
                            fa-circle-notch
                            fa-spin
                            mr-1
                        "
                    ></i>

                    <i
                        v-else
                        class="
                            fa-solid
                            fa-floppy-disk
                            mr-1
                        "
                    ></i>

                    {{
                        saving
                            ? 'Guardando...'
                            : 'Guardar cargo extra'
                    }}

                </button>

            </div>

        </div>

    </modal>

</template>


<style scoped>
.extra-contract-form {
    --primary: #5672a5;
    --primary-dark: #304d7d;
    --primary-soft: #eef3fb;

    --success: #269b74;
    --success-soft: #eaf8f3;

    --warning: #d99b24;
    --warning-soft: #fff8e8;

    --danger: #d84d5d;
    --danger-soft: #fff0f2;

    --border: #dfe5ee;
    --surface: #ffffff;
    --background: #f5f7fb;

    --text: #1f2937;
    --muted: #6b7280;

    min-height: 430px;

    color: var(--text);

    background: var(--background);
}


/* =========================================
   HEADER
========================================= */

.form-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    padding: 18px 22px;

    color: #ffffff;

    background:
        linear-gradient(
            135deg,
            var(--primary-dark),
            var(--primary)
        );
}


.form-header__content {
    display: flex;

    align-items: center;

    gap: 14px;

    min-width: 0;
}


.form-header__icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 46px;
    height: 46px;

    color: #ffffff;

    background:
        rgba(
            255,
            255,
            255,
            .15
        );

    border:
        1px solid
        rgba(
            255,
            255,
            255,
            .2
        );

    border-radius: 12px;

    font-size: 22px;
}


.form-header__title {
    margin: 0;

    font-size: 18px;
    font-weight: 700;
}


.form-header__subtitle {
    margin: 3px 0 0;

    color:
        rgba(
            255,
            255,
            255,
            .78
        );

    font-size: 12px;
}


.form-close {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 36px;
    height: 36px;

    color: #ffffff;

    background:
        rgba(
            255,
            255,
            255,
            .12
        );

    border: 0;
    border-radius: 50%;

    cursor: pointer;

    transition: .2s ease;
}


.form-close:hover {
    background:
        rgba(
            255,
            255,
            255,
            .24
        );

    transform:
        rotate(
            90deg
        );
}


/* =========================================
   BODY
========================================= */

.form-body {
    max-height:
        calc(
            100vh - 185px
        );

    padding: 22px;

    overflow-y: auto;
}


/* =========================================
   SECCIONES
========================================= */

.form-section {
    padding: 20px;

    margin-bottom: 18px;

    background: var(--surface);

    border:
        1px solid
        var(--border);

    border-radius: 12px;

    box-shadow:
        0 3px 10px
        rgba(
            15,
            23,
            42,
            .04
        );
}


.form-section:last-child {
    margin-bottom: 0;
}


.form-section--concepts {
    padding-left: 0;
    padding-right: 0;
}


.form-section--concepts
.section-header {
    padding-left: 20px;
    padding-right: 20px;
}


.section-header {
    display: flex;

    align-items: flex-start;

    gap: 12px;

    margin-bottom: 18px;
}


.section-header--actions {
    align-items: center;
    justify-content: space-between;
}


.section-header__left {
    display: flex;

    align-items: flex-start;

    gap: 12px;
}


.section-number {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 30px;
    height: 30px;

    color: var(--primary-dark);

    background: var(--primary-soft);

    border-radius: 50%;

    font-size: 13px;
    font-weight: 700;
}


.section-title {
    margin: 1px 0 3px;

    color: var(--text);

    font-size: 15px;
    font-weight: 700;
}


.section-description {
    margin: 0;

    color: var(--muted);

    font-size: 12px;
}


/* =========================================
   SELECCIÓN DE CONTRATO
========================================= */

.contract-selector-grid {
    display: grid;

    grid-template-columns:
        repeat(
            3,
            minmax(
                0,
                1fr
            )
        );

    gap: 16px;
}


.form-group {
    margin-bottom: 0;
}


.field-label {
    display: block;

    margin-bottom: 6px;

    color: #374151;

    font-size: 12px;
    font-weight: 600;
}


.required-mark {
    color: var(--danger);
}


.field-help {
    display: block;

    margin-top: 4px;

    color: var(--muted);

    font-size: 10px;
}


.form-control {
    min-height: 38px;

    border-color: #d5dce6;
    border-radius: 7px;

    font-size: 12px;
}


.form-control:focus {
    border-color: var(--primary);

    box-shadow:
        0 0 0 3px
        rgba(
            86,
            114,
            165,
            .12
        );
}


.form-control:disabled {
    cursor: not-allowed;

    background: #f3f5f8;

    color: #9ca3af;
}


.select-loading-wrapper {
    position: relative;
}


.select-loading-icon {
    position: absolute;

    top: 50%;
    right: 10px;

    color: var(--primary);

    font-size: 12px;

    pointer-events: none;

    transform:
        translateY(
            -50%
        );
}


/* =========================================
   CONTEXTO
========================================= */

.selection-context {
    display: flex;

    align-items: center;

    gap: 10px;

    margin-top: 16px;

    padding: 11px 13px;

    color: #42658f;

    background: #eef5ff;

    border: 1px solid #d6e6fb;
    border-radius: 10px;
}


.selection-context__icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 32px;
    height: 32px;

    color: var(--primary-dark);

    background: #ffffff;

    border-radius: 50%;
}


.selection-context small,
.selection-context strong {
    display: block;
}


.selection-context small {
    color: #6a83a0;

    font-size: 9px;

    text-transform: uppercase;

    letter-spacing: .3px;
}


.selection-context strong {
    margin-top: 2px;

    color: var(--primary-dark);

    font-size: 11px;
}


/* =========================================
   BOTÓN AGREGAR
========================================= */

.add-concept-button {
    flex: 0 0 auto;

    border-color: var(--primary);

    color: var(--primary-dark);

    font-size: 11px;
}


.add-concept-button:hover {
    color: #ffffff;

    background: var(--primary);

    border-color: var(--primary);
}


/* =========================================
   TABLA DE CONCEPTOS
========================================= */

.concept-table-wrapper {
    overflow-x: auto;

    border-top:
        1px solid
        var(--border);

    border-bottom:
        1px solid
        var(--border);
}


.concept-table {
    width: 100%;
    min-width: 650px;

    margin: 0;

    border-collapse: separate;
    border-spacing: 0;
}


.concept-table th {
    padding: 11px 13px;

    color: #4b5563;

    background: #f3f5f8;

    border-bottom:
        1px solid
        var(--border);

    font-size: 11px;
    font-weight: 700;

    text-transform: uppercase;
}


.concept-table td {
    padding: 12px 13px;

    vertical-align: middle;

    border-bottom:
        1px solid
        #edf0f4;

    font-size: 12px;
}


.concept-table tbody tr:hover {
    background: #fafbfd;
}


.concept-table tbody tr:last-child td {
    border-bottom: 0;
}


.amount-column {
    width: 210px;

    text-align: right;
}


.actions-column {
    width: 58px;
}


.concept-input {
    display: flex;

    align-items: center;

    gap: 9px;
}


.concept-index {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 26px;
    height: 26px;

    color: var(--primary-dark);

    background: var(--primary-soft);

    border-radius: 50%;

    font-size: 10px;
    font-weight: 700;
}


.amount-field {
    display: flex;

    position: relative;
}


.amount-field__symbol {
    display: flex;

    align-items: center;
    justify-content: center;

    width: 36px;

    color: #4b5563;

    background: #f3f5f8;

    border: 1px solid #d5dce6;
    border-radius: 7px 0 0 7px;

    font-weight: 700;
}


.amount-field__input {
    border-left: 0;
    border-radius: 0 7px 7px 0;

    font-size: 13px;
    font-weight: 700;
}


.remove-concept-button {
    width: 32px;
    height: 32px;

    padding: 0;

    border-radius: 7px;
}


/* =========================================
   TOTAL
========================================= */

.concept-total {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 15px;

    padding: 14px 20px;

    background: var(--primary-soft);

    border-top:
        1px solid
        #d7e1f2;
}


.concept-total small,
.concept-total span {
    display: block;
}


.concept-total small {
    color: var(--muted);

    font-size: 9px;
}


.concept-total span {
    margin-top: 1px;

    color: var(--primary-dark);

    font-size: 11px;
    font-weight: 600;
}


.concept-total > strong {
    color: var(--primary-dark);

    font-size: 19px;
    font-weight: 700;

    white-space: nowrap;
}


/* =========================================
   ESTADOS VACÍO / CARGANDO
========================================= */

.loading-state,
.empty-state {
    display: flex;

    align-items: center;
    justify-content: center;

    gap: 12px;

    min-height: 155px;

    padding: 30px;

    color: var(--muted);

    text-align: left;
}


.loading-state i {
    color: var(--primary);

    font-size: 22px;
}


.empty-state__icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    width: 48px;
    height: 48px;

    color: var(--primary);

    background: var(--primary-soft);

    border-radius: 50%;

    font-size: 20px;
}


.empty-state strong {
    display: block;

    color: var(--text);

    font-size: 13px;
}


.empty-state p {
    max-width: 480px;

    margin: 3px 0 0;

    font-size: 11px;
}


/* =========================================
   FOOTER
========================================= */

.form-footer {
    display: flex;

    align-items: center;
    justify-content: flex-end;

    gap: 10px;

    padding: 14px 22px;

    background: #ffffff;

    border-top:
        1px solid
        var(--border);
}


.footer-button {
    min-width: 120px;

    padding: 9px 15px;

    border-radius: 7px;

    font-size: 12px;
}


.footer-button--save {
    min-width: 180px;
}


/* =========================================
   RESPONSIVE
========================================= */

@media (
    max-width: 768px
) {

    .form-body {
        padding: 14px;
    }


    .contract-selector-grid {
        grid-template-columns:
            1fr;
    }


    .section-header--actions {
        align-items: flex-start;

        flex-direction: column;
    }


    .add-concept-button {
        width: 100%;
    }


    .form-footer {
        flex-direction:
            column-reverse;
    }


    .footer-button {
        width: 100%;
    }

}
</style>
